import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type RelocationCost = ResultOf<
  typeof relocationCostQuery
>["relocationCost"];

export const relocationCostQuery = graphql(`
  query RelocationCost($input: RelocationCostInput!) {
    relocationCost(input: $input) {
      total_cost_amount
      total_refund_amount
      pay_now_total_amount
      pay_later_total_amount
      discounted_units
      full_price_units
      pay_now_holding_deposit_amount
      pay_now_full_price_units_deposit_amount
      pay_now_booking_fee_amount
      pay_later_discounted_amount
      pay_later_full_price_amount
    }
  }
`);
